import React, { useEffect } from "react";
import "./css/Services.css";

const services = [
  {
    title: "MLM Software Development",
    description:
      "Customized software solutions for your MLM business with security and scalability.",
  },
  {
    title: "Lead Generation",
    description:
      "High-quality leads to help you grow your MLM network efficiently.",
  },
  {
    title: "Training & Support",
    description:
      "Guidance, training, and 24/7 support for you and your team members.",
  },
  {
    title: "Digital Marketing",
    description:
      "Email, SMS, and social media marketing to boost your MLM business.",
  },
  {
    title: "Team Management Tools",
    description:
      "Track your team’s performance, commissions, and growth easily.",
  },
  {
    title: "Consultation",
    description:
      "Expert consultation to plan and execute MLM strategies successfully.",
  },
  {
    title: "Latest Updates",
    description:
      "Latest Update to plan and execute MLM strategies successfully.",
  },
  {
    title: "Solution",
    description:
      "Solution consultation to plan and execute MLM strategies successfully.",
  },
];

export default function Services() {
  useEffect(() => {
    document.title = "Services | My MLM Website";
  }, []);
  return (
    <div className="services-container">
      <h1 className="services-heading">Our Services</h1>
      <p className="services-description">
        हम आपकी MLM Business की growth के लिए multiple services provide करते
        हैं। आप हमारी services का इस्तेमाल करके अपनी team और revenue दोनों बढ़ा
        सकते हैं।
      </p>

      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
